<template>
  <div class="px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow">
    <div class="bg-image brand-img"></div>
    <div class="py-8 flex-col-grow">
      <transition name="fade" @after-leave="afterTransition" appear>
        <div v-if="show" class="flex-col-grow items-center">
          <div class="w-full">
            <h1 class="text-center font-medium text-2xl text-base-color-alt">
              Pago Express
            </h1>
            <div class="my-6 lg:my-3 flex justify-between">
              <CreditorInfo
                :creditor-name="creditorName"
                :creditor-tax-id="creditorTaxId"
              />
              <button
                v-if="voucherService.hasMultipleVouchers()"
                class="ml-3 font-medium text-base-color"
                @click="nextVoucher"
              >
                Voucher Siguiente
              </button>
            </div>
          </div>
          <div
            class="
              w-full
              my-1
              lg:my-6
              flex-col-grow
              lg:flex-row
              2xl:pb-20
              items-center
              justify-center
            "
          >
            <VoucherCard
              :voucher="voucher"
              @pay-voucher="showPaymentMethodsModal"
            />
            <div class="my-12 sm:my-20 lg:my-0 lg:ml-20 xl:ml-24 2xl:ml-36">
              <h1
                class="
                  hidden
                  lg:block
                  mx-auto
                  mb-1
                  font-medium
                  text-2xl text-center
                  tracking-tight
                  text-base-color-alt
                "
              >
                Resumen
              </h1>
              <p class="mx-auto w-60 sm:w-full lg:w-52 text-center text-gray-4">
                Revisa los vouchers y selecciona tu medio de pago.
              </p>
              <img
                class="mx-auto my-5"
                width="267"
                src="../assets/img/payment-methods.png"
              />
              <a href="https://www.leasity.cl">
                <img
                  class="mx-auto h-7 lg:h-9"
                  src="../assets/img/leasity-brand.svg"
                />
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <div class="hidden w-full h-16 bg-gray-1 brand-banner"></div>
  <div
    v-if="showPaymentModal"
    class="fixed w-screen h-screen bg-gray-1 opacity-20"
  ></div>
  <div
    v-if="showPaymentModal"
    class="fixed flex justify-center items-center w-screen h-screen"
  >
    <div class="flex items-center w-72 flex-col bg-white rounded-md shadow-md">
      <p class="text-lg mt-3">Selecciona tu método de pago</p>
      <img
        class="w-9/12 mt-3 mb-5 cursor-pointer"
        src="https://www.leasity.cl/assets/img/brands/servipag.png"
        width="200px"
        alt="Servipag"
        @click="payVoucher('servipag')"
      />
      <img
        class="w-9/12 cursor-pointer"
        src="https://s3.amazonaws.com/static.khipu.com/buttons/2021/200x75-white.png"
        width="200px"
        alt="Khipu"
        @click="payVoucher('khipu')"
      />
      <img
        class="w-7/12 cursor-pointer"
        src="https://www.leasity.cl/assets/img/brands/otp.svg"
        width="200px"
        alt="Otros Pagos"
        @click="payVoucher('otp')"
      />
      <a
        class="text-center text-gray-2 mt-2 mb-4"
        href="https://www.leasity.cl/assets/documents/guia_de_pagos.pdf"
        target="_blank"
        >¿No sabes cuál escoger?<br />Revisa nuestra guía de pagos</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import CreditorInfo from '@/components/CreditorInfo.vue';
import VoucherCard from '@/components/VoucherCard.vue';
import { DefaultVoucher, Voucher } from '@/models/voucher';
import { inject } from '@vue/runtime-core';
import { VouchersService, VOUCHER_SERVICE } from '@/services/vouchers-service';

@Options({
  components: {
    CreditorInfo,
    VoucherCard,
  },
  // TODO: Remove
  // computed: {
  //   voucher: () => {
  //     const voucherService = inject<VouchersService>(VOUCHER_SERVICE);
  //     return voucherService?.getCurrentVoucher();
  //   },
  // },
})
export default class VoucherView extends Vue {
  show = true;
  voucher!: Voucher;
  creditorName!: string | undefined;
  creditorTaxId!: string;
  selectedVoucherId!: number;
  showPaymentModal = false;
  selectedPaymentMethod = 'servipag';
  private voucherService!: VouchersService;

  beforeCreate(): void {
    const voucherService = inject<VouchersService>(VOUCHER_SERVICE);

    if (!voucherService) {
      console.error('No voucher service injected');
      this.$router.push({ name: 'error' });
    }

    this.voucherService = voucherService as VouchersService;

    this.voucher = this.voucherService.getCurrentVoucher();

    if (this.voucher.id === DefaultVoucher.id) {
      this.$router.replace('search-vouchers');
    }

    this.creditorName = this.voucherService.getCreditorName();
    this.creditorTaxId = this.voucherService.getCreditorTaxId();
  }

  afterTransition(): void {
    if (this.selectedVoucherId) {
      let form = document.createElement('form');
      form.setAttribute(
        'action',
        'https://payments.leasity.cl/api/pay-vouchers'
      );
      form.setAttribute('method', 'post');
      let providerNode = document.createElement('input');
      providerNode.setAttribute('type', 'hidden');
      providerNode.setAttribute('name', 'provider');
      providerNode.setAttribute('value', this.selectedPaymentMethod);
      let idsNode = document.createElement('input');
      idsNode.setAttribute('type', 'hidden');
      idsNode.setAttribute('name', 'ids');
      idsNode.setAttribute('value', '' + this.selectedVoucherId);
      form.appendChild(providerNode);
      form.appendChild(idsNode);
      document.body.appendChild(form);
      form.submit();
    }
  }

  nextVoucher(): void {
    // TODO: Fix
    this.voucher = this.voucherService.nextVoucher();
    console.log(this.voucher);
    this.$forceUpdate();
  }

  payVoucher(method: string): void {
    this.showPaymentModal = false;
    this.selectedPaymentMethod = method;
    this.show = false;
    this.selectedVoucherId = this.voucher.id;
  }

  showPaymentMethodsModal(): void {
    this.showPaymentModal = true;
  }
}
</script>
